module.exports = __webpack_public_path__ + "static/media/gt-america-standard-medium.f052b560.woff2";